
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

@Component({
  components: {
  }
})
export default class ProductActions extends Vue {
  @Getter activeRestaurant!: Restaurant;
  @InjectReactive() isMobile!: boolean;
  @InjectReactive('requestInProgress') requestInProgress!: boolean;

  @Prop({ default: [] }) validations: any[];
  @Prop({ default: false }) isValid: boolean;
  @Prop({ default: false }) isNavigationSelectable: boolean;
  @Prop({ default: false }) showOptionModifiers: boolean;
  @Prop({}) editingProduct: any;

  get isAddToCartDisabled() {
    return !this.isValid || this.activeRestaurant?.supportsOnlineOrdering === false;
  }

  get isOrderingDisabled() {
    return this.activeRestaurant?.orderingDisabled || false;
  }
}
